import { Entity } from '../enums/entity.enums';
import { EnableDisableButtonData } from '../type/button.types';
import {
  BasicMerchant,
  BasicMerchantBranch,
  BasicPartner,
  BasicReseller,
} from '../type/entity.types';

export const convertBasicPartnersToEnableDisableData = (
  data: BasicPartner[]
): EnableDisableButtonData[] => {
  return data.map((item) => {
    return {
      accountId: item.accountId,
      isActive: item.isActive,
      onboardingStatus: item.onboardingStatus,
      entityId: item.partnerId,
      entityType: Entity.PARTNER,
      entityName: item.partnerName,
    };
  });
};

export const convertBasicResellersToEnableDisableData = (
  data: BasicReseller[]
): EnableDisableButtonData[] => {
  return data.map((item) => {
    return {
      accountId: item.accountId,
      isActive: item.isActive,
      onboardingStatus: item.onboardingStatus,
      entityId: item.resellerId,
      entityType: Entity.RESELLER,
      entityName: item.resellerName,
    };
  });
};

export const convertBasicMerchantsToEnableDisableData = (
  data: BasicMerchant[]
): EnableDisableButtonData[] => {
  return data.map((item) => {
    return {
      accountId: item.accountId,
      isActive: item.isActive,
      onboardingStatus: item.onboardingStatus,
      entityId: item.merchantId,
      entityType: Entity.MERCHANT,
      entityName: item.merchantName,
    };
  });
};

export const convertBasicBranchesToEnableDisableData = (
  data: BasicMerchantBranch[]
): EnableDisableButtonData[] => {
  return data.map((item) => {
    return {
      accountId: item.accountId,
      isActive: item.isActive,
      onboardingStatus: item.onboardingStatus,
      entityId: item.branchId,
      entityType: Entity.BRANCH,
      entityName: item.branchName,
    };
  });
};
